import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/no-photo.png'


const _hoisted_1 = { class: "basket__container" }
const _hoisted_2 = {
  key: 0,
  class: "basket__main"
}
const _hoisted_3 = { class: "basket__img" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "basket__item-body" }
const _hoisted_7 = { class: "basket__item-title" }
const _hoisted_8 = {
  key: 0,
  class: "basket__item-gramm"
}
const _hoisted_9 = { class: "basket__item-total" }
const _hoisted_10 = { class: "basket__item-prices" }
const _hoisted_11 = { class: "basket__item-price" }
const _hoisted_12 = {
  key: 0,
  class: "basket__item-sale"
}
const _hoisted_13 = {
  key: 0,
  class: "basket__item-count"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "basket__item-count-body" }
const _hoisted_16 = { class: "basket__item-count-number" }
const _hoisted_17 = { class: "basket__item-count-price" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "basket__calculation"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "basket__price-body" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "basket__caption" }, "Товары"),
  /*#__PURE__*/_createElementVNode("span", { class: "basket__price" }, "13 900р")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "basket__price-body"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", { class: "basket__caption" }, "Доставка", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "basket__price" }, "240р", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "basket__price-body"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h5", { class: "basket__caption basket__caption--small" }, "Сегодня: 1 товар", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "basket__price basket__price--small" }, "100", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "basket__price-body"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h5", { class: "basket__caption basket__caption--small" }, " 16 февраля: 1 товар ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "basket__price basket__price--small" }, "100", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "basket__bottom" }
const _hoisted_34 = { class: "basket__total" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "basket__total-title" }, "Итого", -1)
const _hoisted_36 = { class: "basket__total-price" }
const _hoisted_37 = { class: "basket__consent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ACounter = _resolveComponent("ACounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.updateData.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basket.items, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "basket__item",
              key: idx
            }, [
              _createElementVNode("div", _hoisted_3, [
                (item.images.length != 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      width: "100",
                      alt: item.name,
                      src: item.images[0]
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      width: "100",
                      alt: item.name,
                      src: _imports_0
                    }, null, 8, _hoisted_5))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 460 г • " + _toDisplayString(_ctx.priceFormat(item.price)) + " / кг ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.priceFormat(item.price)) + " / " + _toDisplayString(item.measure), 1),
                    (item.discountPercent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.priceFormat(item.basePrice)) + " / " + _toDisplayString(item.measure), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ACounter, {
                    modelValue: _ctx.updateData[idx].quantity,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.updateData[idx].quantity) = $event),
                    min: item.ratio,
                    max: item.maxQuantity,
                    price: item.price,
                    ratio: item.ratio,
                    measure: item.measure,
                    loading: _ctx.loading,
                    id: item.id,
                    onChange: _ctx.changeBasket,
                    onDeleteItem: _ctx.deleteItemBasket
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "price", "ratio", "measure", "loading", "id", "onChange", "onDeleteItem"]),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("button", {
                          class: "basket__item-count-btn basket__item-count-btn--remove",
                          onClick: ($event: any) => (_ctx.changeQuantity(idx, -item.ratio))
                        }, null, 8, _hoisted_14),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.updateData[idx].quantity) + " " + _toDisplayString(item.measure), 1),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.priceFormat(item.ratioPrice)), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "basket__item-count-btn basket__item-count-btn--add",
                          onClick: ($event: any) => (_ctx.changeQuantity(idx, item.ratio))
                        }, null, 8, _hoisted_18)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          false
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_24))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_28))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_32))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("span", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.priceFormat(_ctx.basket?.total?.price)), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.nextOrder()), ["prevent"])),
        class: "basket__btn"
      }, " Перейти к оформлению заказа "),
      _createElementVNode("span", _hoisted_37, [
        _createTextVNode("Нажимая на кнопку вы соглашаетесь с "),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPersonalData && _ctx.showPersonalData(...args))),
          class: "basket__consent basket__consent--link"
        }, "условия обработки персональных данных")
      ])
    ])
  ]))
}